/* eslint-disable @typescript-eslint/no-explicit-any */

import axios, { HttpStatusCode } from 'axios'

import { toast } from '@shared/components/Toast/utils/toast'

type HandleApiOptions = {
  err: any
  otherStatus?: number[]
  extraValidations?: boolean[]
  onError?: () => void
}

export class HandleApiErrors {
  static handle(options: HandleApiOptions): void {
    const { err, otherStatus, extraValidations, onError } = options

    const validations = {
      isAxiosError: axios.isAxiosError(err),
      isNotError403: err.response?.status !== HttpStatusCode.Forbidden,
    }

    if (otherStatus?.length) {
      otherStatus.forEach((status) => {
        Object.assign(validations, { [`isNotError${status}`]: err.response?.status !== status })
      })
    }

    if (extraValidations?.length) {
      extraValidations.forEach((validation, index) => {
        Object.assign(validations, { [`validation-${index}`]: validation })
      })
    }

    if (Object.values(validations).every((validation) => validation))
      toast(err.response?.data.message || 'Houve algum erro, tente novamente mais tarde! :(', { type: 'error' })

    if (onError) onError()
  }
}
